import { notification } from '@ss/mtd-react';
import { jump } from '@utils/navigate';
import { getDownFileUrlApi } from '@service/common';
import { whichBrowserInfo } from '@utils/tools';

// 浏览器下载
function downFileInWeb(href, fileName, target = '_blank') {
  const eleLink = document.createElement('a');
  eleLink.download = fileName;
  eleLink.style.display = 'none';
  eleLink.href = href;
  eleLink.target = target;
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  // document.body.removeChild(eleLink);
}

// 使用xhr下载文件，从招聘人才子项目拷贝过来的
export const xhrDownload = (fileId: string, fileName: string, resumeUnionId: string) => {
  const xhr = new window.XMLHttpRequest();
  xhr.open('GET', `/api/official/resume/attachment/download?fileId=${fileId}&resumeUnionId=${resumeUnionId}`, true);
  xhr.responseType = 'arraybuffer';
  xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
  xhr.onload = () => {
    let res;
    if (xhr?.response instanceof ArrayBuffer) {
      const utf8decoder = new TextDecoder();
      const u8arr = new Uint8Array(xhr?.response);
      // 将二进制数据转为字符串
      const temp = utf8decoder.decode(u8arr);
      if (temp.includes('{"data"')) res = JSON.parse(temp);
      else res = xhr?.response;
    }
    if (res.status === 0) {
      notification.error({
        message: res.message || '下载附件失败',
      });
      return false;
    }
    if (res.status === 404) {
      notification.error({
        message: '下载附件失败',
      });
      return false;
    }
    if (res.status === 401) {
      notification.error({
        message: '登录失效，请重新登录',
      });
      const targetUrl = `${window.location.origin}/web/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
      jump(targetUrl, { isAppendQuery: false });
      return false;
    }
    const blob = new window.Blob([xhr.response]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    return true;
  };
  xhr.send();
};

// 下载作品集
export const downFile = async (fileId: string, fileName: string, resumeUnionId: string) => {
  const href = await getDownFileUrlApi(fileId, resumeUnionId);
  const whichBrowser = whichBrowserInfo();
  if (whichBrowser.isSafariBrowser) {
    downFileInWeb(href, fileName, '_self');
    return;
  }
  downFileInWeb(href, fileName);
};
